export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40" />
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-primary-200/20 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-10 w-[350px] h-[350px] bg-accent-200/20 rounded-full blur-3xl" />

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm" />
              <span>千万漫画迷的共同选择</span>
            </div>

            <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              香香漫画
              <span className="block text-primary-600 mt-1">
                韩漫日漫国漫免费在线阅读平台
              </span>
            </h1>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              香香漫画网为您提供香香漫画官网入口与网址，汇聚海量韩漫、日漫、国漫资源，全部免费在线阅读。采用下拉式追更模式，无需翻页等待，一滑到底畅快阅读。无论你热爱热血战斗、甜蜜恋爱还是悬疑推理，这里都有好看的漫画免费全集等你探索。
            </p>

            <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              每日稳定更新，内容覆盖校园、都市、奇幻、古风等多元题材，日更速度与漫画质量双重保障。香香漫画网址安全直达，是你追更漫画的不二之选。
            </p>

            <div className="mt-7 flex items-center justify-center lg:justify-start gap-6 md:gap-10">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                  10万+
                </div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">
                  每日更新
                </div>
                <div className="text-xs text-foreground-500 mt-1">稳定追更</div>
              </div>
              <div className="w-px h-10 bg-background-300" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                  永久免费
                </div>
                <div className="text-xs text-foreground-500 mt-1">安全直达</div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line text-lg" />
                开始阅读热门漫画
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-secondary-400 text-foreground-700 font-semibold rounded-full hover:bg-secondary-100 transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line text-lg" />
                查看人气榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-300/30 via-accent-200/25 to-secondary-300/30 rounded-3xl blur-xl" />
              <div className="relative bg-background-50 rounded-2xl overflow-hidden border border-background-200/70">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20illustration%20of%20a%20cozy%20reading%20corner%20with%20an%20open%20manga%20book%20displayed%20on%20a%20wooden%20table%2C%20soft%20warm%20lighting%20from%20a%20nearby%20lamp%2C%20bookshelf%20with%20colorful%20comic%20volumes%20in%20the%20background%2C%20artistic%20anime-style%20composition%2C%20gentle%20candlelight%20ambiance%2C%20cream%20and%20peach%20pastel%20tones%2C%20peaceful%20atmosphere%2C%20clean%20and%20minimal%20style&width=1200&height=1600&seq=hero-manga-visual&orientation=portrait"
                  alt="香香漫画 - 韩漫日漫国漫免费在线阅读，下拉式追更体验"
                  className="w-full h-auto object-cover aspect-[3/4]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}